<core-page-header *ngIf="client.getLogoURL()" class="{{ headerClass }}"></core-page-header>

<div class="page-wrapper view-wrapper">
    <div class="page-inner site-wrapper">
        <div class="page-content-wrapper wrapper site-content {{ wrapperClass }}">
            <main class="page-content container-fluid mobile-padding category-default" role="main">
                <div class="{{ containerClass }}">
                    <router-outlet></router-outlet>
                </div>
            </main>
            <core-page-footer></core-page-footer>
        </div>
        <!--        <div class="page-content-overlay" (click)="closeMobileNav($event)" data-class="mobile-nav-on"></div>-->
    </div>
</div>
